module.exports = __webpack_public_path__ + "img/ltweight.48174e23.png";